import type { ErrorBody } from './envelope.js';

export class ApiError extends Error {
  readonly status: number;
  readonly code: string;
  readonly details?: Record<string, unknown>;
  readonly requestId?: string;
  readonly body: unknown;

  constructor(
    status: number,
    code: string,
    message: string,
    body: unknown,
    details?: Record<string, unknown>,
    requestId?: string
  ) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
    this.body = body;
    if (details !== undefined) this.details = details;
    if (requestId !== undefined) this.requestId = requestId;
  }
}

export class NetworkError extends Error {
  readonly cause: unknown;
  constructor(message: string, cause?: unknown) {
    super(message);
    this.name = 'NetworkError';
    this.cause = cause;
  }
}

export class TimeoutError extends Error {
  constructor(public readonly timeoutMs: number) {
    super(`Request timed out after ${timeoutMs}ms`);
    this.name = 'TimeoutError';
  }
}

export function isApiError(value: unknown): value is ApiError {
  return value instanceof ApiError;
}

export function fromErrorBody(status: number, body: unknown): ApiError {
  if (body && typeof body === 'object' && 'error' in body) {
    const e = (body as { error: ErrorBody }).error;
    if (e && typeof e === 'object' && typeof e.code === 'string' && typeof e.message === 'string') {
      return new ApiError(status, e.code, e.message, body, e.details, e.request_id);
    }
  }
  const message =
    body && typeof body === 'object' && 'message' in body && typeof (body as { message: unknown }).message === 'string'
      ? ((body as { message: string }).message)
      : `HTTP ${status}`;
  return new ApiError(status, `HTTP_${status}`, message, body);
}
